import { gql } from "urql";
export const UpdatePriorityAttributeMutation = gql `
    mutation UpdatePriorityAttribute(
        $priorityAttributeId: String!
        $priorityStatusId: String
        $tags: [String!]
        $inquiredAt: String
    ) {
        priorityAttributes {
            updatePriorityAttribute(
                priorityAttributeId: $priorityAttributeId
                priorityStatusId: $priorityStatusId
                tags: $tags
                inquiredAt: $inquiredAt
            ) {
                priorityAttributeId
                priorityEntryId
                organizationId
                priorityStatusId
                tags
                inquiredAt
                createdAt
                updatedAt
            }
        }
    }
`;
export const UpdatePriorityAttributeAndSendSimpleEmailMutation = gql `
    mutation UpdatePriorityAttributeAndSendSimpleEmail(
        $priorityAttributeId: String!
        $priorityStatusId: String!
        $subject: String!
        $body: String!
    ) {
        priorityAttributes {
            updatePriorityAttributeAndSendSimpleEmail(
                input: {
                    priorityAttributeId: $priorityAttributeId
                    priorityStatusId: $priorityStatusId
                    subject: $subject
                    body: $body
                }
            ) {
                priorityAttributeId
                priorityEntryId
                organizationId
                priorityStatusId
                tags
                inquiredAt
                createdAt
                updatedAt
            }
        }
    }
`;
